<template>
  <b-modal id="confirmRestoreOrder" ref="confirmRestoreOrder" no-stacking>
    <template slot="modal-title">{{ $t('restoreOrder') }}</template>
    <p v-text="$t('restoreOrderConfirm')" />
    <div slot="modal-footer" class="col-md-12">
      <b-button variant="primary" class="float-lg-right" @click="restoreOrder">{{ $t('confirm') }}</b-button>
      <b-button variant="secondary" class="float-lg-left" v-on:click="cancel">{{ $t('cancel') }}</b-button>
    </div>
  </b-modal>
</template>

<script>
  import OrderService from '@/services/OrderService'

  export default {
    name: "RestoreOrderModal",
    methods: {
      restoreOrder () {
        OrderService.restoreOrders([this.$route.params.id])
          .then(() => {
            this.$bvToast.toast(this.$t('restoreOrderSuccess'), {
              title: this.$t('success'),
              toaster: 'b-toaster-top-center',
              variant: 'success',
              autoHideDelay: 2000
            });
            this.$store.dispatch('orders/getOrder', this.$route.params.id);
            const objectReference = 'order:orderId:' + this.$route.params.id
            this.$store.dispatch('orders/getObjectReference', objectReference);
          })
          .finally(() => {
            this.$bvModal.hide('confirmRestoreOrder')
          })
      },
      cancel () {
        this.$bvModal.hide('confirmRestoreOrder')
      }
    }
  }
</script>
